<template>
  <div class="all">
    <div class="history">
      <img :src="icon" style="width: 24px" alt="" />
      <span>最近点击</span>
    </div>
    <div style="padding: 0 40px;">
      <applicationHistory :apps="historyApps" />
    </div>
    <!-- <div class="header_top">
      <img :src="icon" style="width: 24px" alt="" />
      <span>常用应用</span>
    </div> -->
    <el-tabs v-model="activeName" class="header_tab">
      <el-tab-pane v-for="group in appGroups" :key="group.appCode" :name="group.appCode" :label="group.appName">
        <applicationList :apps="group.children" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import platformService from "@/CommonDP/service/platform-service";
import treeUtils from "@/CommonDP/utils/treeUtils";
import applicationList from "@/CommonDP/pages/mainMg/application/applicationList";
import applicationHistory from "@/CommonDP/pages/mainMg/application/applicationHistory";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  components: { applicationList, applicationHistory },
  data() {
    return {
      appGroups: [],
      icon: require("@/CommonDP/assets/settings/application.png"),
      activeName: "all",
      historyApps: []
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    navName() {
      return this.$route.matched[1].name;
    },
    meauList() {
      if (this.authRoutes && this.authRoutes.length > 0) {
        const list = this.authRoutes.find(({ permissionKey }) => permissionKey === this.navName);
        return [list] || [];
      }
      return [];
    }
  },

  async mounted() {
    await this.loadApps();
    await this.getAppHistoryList();
  },

  methods: {
    async getAppHistoryList() {
      const res = await platformService.getAppHistoryList("app", "web", this.enterpriseId);
      this.historyApps = res.data || [];
    },
    async loadApps() {
      const res = await platformService.queryPlatformApps(this.enterpriseId);
      if (!res.data || res.data.length === 0) {
        return;
      }
      const groups = res.data;
      const allApps = [];
      treeUtils.wtravelAll(groups, true, (node) => {
        if (node.type && node.type === 1) {
          allApps.push(node);
        }
      });
      groups.unshift({
        appCode: "all",
        appName: "全部应用",
        type: 0,
        children: allApps
      });
      const extraItem = globalParams.get("application.applicationAll") || [];
      groups.push(...extraItem);
      this.appGroups = [groups[0]];
    }
  }
};
</script>

<style lang="scss" scoped>
$header-top: 50px;
$header-tab: 30px;
.all {
  height: 100%;
  overflow-y: auto;
  .history {
    padding: var(--middle-space) var(--big-space);
    background: #ffffff;
    border: 1px solid #ebefff;
    display: flex;
    align-items: center;
    margin: var(--middle-space) 0;
    span {
      font-size: 16px;
    }
  }
  .header_top {
    background: #ffffff;
    line-height: $header-top;
    border: 1px solid #ebefff;
    display: flex;
    align-items: center;
    padding: 0 40px;
    span {
      font-size: 16px;
    }
  }
  .header_tab /deep/ .el-tabs__nav-wrap::after {
    height: 0;
  }
  .header_tab {
    padding: 0 40px;
    margin-top: var(--small-space);
  }
}
</style>
